// extracted by mini-css-extract-plugin
export default {"contactInfosContainer":"WDw87dHWeJJOUDyZHCwA","displayContactBtn":"btzWFNxL76yIJAVehD6c","contactInfo":"P9ip7Lq5BF6pkGmufWON"};